import React, { useRef } from 'react';
import { IConfig } from '../../../Interfaces/IConfig';
import { IInvoiceFullObject } from '../../../Interfaces/IInvoice';
import { ILegalTransactionFullObject } from '../../../Interfaces/ILegalTransaction';
import { DocumentRequest } from '../Document/DocumentRequest';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Typography,
} from '@mui/material';
import { Description, RequestQuote } from '@mui/icons-material';
import { InvoiceStateChip } from './InvoiceStateChip';

interface IProps {
  configObject: IConfig;
  invoice: IInvoiceFullObject;
  legalTransactionObject: ILegalTransactionFullObject;
  handleClose?: () => void;
}

export const InvoiceMobile: React.FC<IProps> = ({
  configObject,
  invoice,
  legalTransactionObject,
  handleClose,
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <DocumentRequest
        documentObject={invoice}
        legalTransaction={legalTransactionObject}
        ref={buttonRef}
        disableBtn
      />

      <Box sx={{ mt: 2 }}>
        <Card
          variant='outlined'
          sx={{ cursor: 'pointer' }}
          onClick={() => buttonRef.current?.click()}
        >
          <CardContent>
            <InvoiceStateChip invoice={invoice} />
            <RequestQuote sx={{ float: 'right' }} fontSize='large' />
            <Box sx={{ ml: 2, mt: 1 }}>
              {invoice.FileName.length <= 20
                ? invoice.FileName
                : `${invoice.FileName.substring(0, 19)}...`}
            </Box>
            <Box sx={{ ml: 2, mb: -1 }}>
              <Typography variant='caption'>
                {invoice.Total === null
                  ? '-'
                  : invoice.Total.toLocaleString('de-DE') + ' €'}
              </Typography>
            </Box>
          </CardContent>
          <CardActions>
            <Button>Anfordern</Button>
          </CardActions>
        </Card>
      </Box>
    </>
  );
};
